export default __webpack_public_path__ + "static/media/loading-light.4c6bea4a.gif";